import { useDispatch } from 'react-redux';
import { useFetch } from '@hooks';
import { saveSuccessServiceResponse } from '@store';
import { UseFetchHookOutput } from '@bcp-channels-sharedcomponents-reactjs/core/dist/$hooks';
import {
	TransactionTypeAliasAuthenticationMessageOperationInputDto,
	AliasAuthenticationMessageOperationOutputDto,
} from '@api/izibizi-xp';

export const useFetchAuthenticatorMessage = (): UseFetchHookOutput<
	Omit<TransactionTypeAliasAuthenticationMessageOperationInputDto, 'metadata'>,
	AliasAuthenticationMessageOperationOutputDto
> => {
	const dispatch = useDispatch();
	return useFetch<
		TransactionTypeAliasAuthenticationMessageOperationInputDto,
		AliasAuthenticationMessageOperationOutputDto
	>({
		operationKey: 'aliasAuthenticationMessage',
		withLoading: false,
		onSuccess: (res) => {
			if (res.data) {
				dispatch(saveSuccessServiceResponse({ aliasAuthenticationMessage: res.data }));
			}
		},
	});
};
